import React, { Dispatch, SetStateAction } from 'react'

let setLoading: Dispatch<SetStateAction<boolean>>
// @ts-ignore
const LoaderContext = React.createContext({ loading: false, setLoading })

export const LoaderProvider = LoaderContext.Provider
export default LoaderContext